import { useSelector } from "react-redux";
import { IonCard, IonItem, IonLabel, IonText } from "@ionic/react";
import { selectLocation } from "../../../store/locationShow/selectors/selectLocation";
import { PictureSelector } from "./PictureSelector";
export const InfoSection: React.FC = () => {
  const location = useSelector(selectLocation);
  return (
    <section style={{ maxWidth: 700 }}>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">General</IonText>
      </h2>
      <IonCard>
        <IonItem lines="none">
          <IonLabel>
            <p>Nombre</p>
            <h2 style={{ fontWeight: 500 }}>{location.name}</h2>
          </IonLabel>
        </IonItem>
        <IonItem lines="none">
          <IonLabel>
            <p>Organización</p>
            <h2 style={{ fontWeight: 500 }}>{location.organization?.name || "--"}</h2>
          </IonLabel>
        </IonItem>
      </IonCard>
      <PictureSelector></PictureSelector>
    </section>
  );
};
